import { Spin, Form, Input, Button } from "antd"
import message from "antd/lib/message"
import React, { FC } from "react"
import { useNavigate } from "react-router-dom"
import restful from "../../restful"

const LoginForm: FC = () => {
    const navigate = useNavigate()
    const [loading, setLoading] = React.useState(false)

    async function onFinish(data: any) {
        setLoading(true)
        restful.post('/users/login', data)
            .then((res) => {
                const result = res.data.result
                localStorage.setItem('access_token', result.access_token)
                localStorage.setItem('refresh_token', result.refresh_token)
                localStorage.setItem('expires_at', result.expires_at)
                setTimeout(() => { navigate('/') }, 1000)
            })
            .catch((err) => {
                console.log(err, err.response)
                let msg = err.message
                if (err.response)
                    msg = err.response.data.message
                message.error(msg)
            })
            .finally(() => setLoading(false))
    }

    return (
        <Spin spinning={loading} >
            <Form
                name="login"
                layout="vertical"
                onFinish={onFinish}
                autoComplete='off'
            >
                <Form.Item label="موبایل" name="mobile"
                    rules={[
                        { required: true, message: "این فیلد ضروری است" },
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="پسورد"
                    name="password"
                    rules={[
                        { required: true, message: "این فیلد ضروری است" },
                    ]}
                >
                    <Input type="password" />
                </Form.Item>
                <Button
                    block
                    type="primary"
                    htmlType="submit"
                >
                    ورود
                </Button>
            </Form>
        </Spin>
    );
}

export default LoginForm